export function restErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim()) return error.message
  if (typeof error === 'string' && error.trim()) return error
  if (!error || typeof error !== 'object') return fallback

  const record = error as { message?: unknown; error?: unknown }
  if (typeof record.message === 'string' && record.message.trim()) return record.message
  if (typeof record.error === 'string' && record.error.trim()) return record.error
  if (record.error && typeof record.error === 'object' && 'message' in record.error) {
    const nested = (record.error as { message?: unknown }).message
    if (typeof nested === 'string' && nested.trim()) return nested
  }
  return fallback
}
